export default "__VITE_ASSET__3e60d777__"